import React, { useState, useEffect } from 'react';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import RealTimeTrendGraphItemInfo from './RealTimeTrendGraphItemInfo';
import { RealTimeTrendSettingModel, GetRealTimeTrendSettingModelList } from './RealTimeTrendGraph';

type Props = {
  selectGroupNo: number;
  trendSettingList: RealTimeTrendSettingModel[];
  onChangeTrandSettingData: (datas: RealTimeTrendSettingModel[]) => void;
  onshowRealTimeTrendSettingDialog: () => void;
};

const RealTimeTrendGraphItemInfoList: React.FC<Props> = (props) => {
  //表示チェックボックス選択
  const isShowOnChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    var tmp = props.trendSettingList;
    tmp[index].IsShow = tmp[index].IsShow == true ? false : true;
    props.onChangeTrandSettingData(tmp);
  };

  //背景選択
  const isRowSelectClick = (index: number) => {
    console.time('[RealTimeTrendGraphItemInfoList] isRowSelectClick - timer');
    var tmp = props.trendSettingList;
    if (tmp[index].PLCNo !== '0') {
      tmp.forEach((row) => (row.IsRowSelect = false));
      tmp[index].IsRowSelect = true;
    }
    props.onChangeTrandSettingData(tmp);
    console.timeEnd('[RealTimeTrendGraphItemInfoList] isRowSelectClick - timer');
  };

  return (
    <div style={{ display: 'flex' }}>
      {props.trendSettingList?.map((row, index) => (
        <RealTimeTrendGraphItemInfo
          setData={row}
          isShowOnChange={isShowOnChange}
          isRowSelectClick={isRowSelectClick}
          isRowSelectDoubleClick={props.onshowRealTimeTrendSettingDialog}
        />
      ))}
    </div>
  );
};

export default RealTimeTrendGraphItemInfoList;
